(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const hiddenClass = 'monoree-chat-obscures-controls';
  let frame = 0;
  const watchedRoots = new WeakSet();
  const layoutRoots = '#MainContent, .section-header, cart-drawer, .cart__footer, .cart-drawer__footer, .monoree-sticky-atc, .mobile-facets__footer, .monoree-quick-add-modal, .monoree-quick-add-button, .monoree-category-navigation, shopify-chat';
  const layoutObserver = new MutationObserver(entries => {
    if (entries.some(entry => entry.target.closest?.(layoutRoots) ||
      [...entry.addedNodes, ...entry.removedNodes].some(node => node.nodeType === 1 &&
        (node.matches(layoutRoots) || node.querySelector(layoutRoots))))) schedule();
  });
  const overlaps = (a, b) => a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
  function update() {
    frame = 0;
    if (!mobile.matches) {
      document.body.classList.remove(hiddenClass);
      return;
    }
    const chat = document.querySelector('shopify-chat');
    const outer = chat?.shadowRoot;
    const root = outer?.querySelector('shopify-agent-runtime')?.shadowRoot || outer;
    for (const observed of [outer, root]) {
      if (!observed || watchedRoots.has(observed)) continue;
      watchedRoots.add(observed);
      new MutationObserver(schedule).observe(observed, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
    }
    const launcher = root?.querySelector('[part~="activator"]');
    if (!mobile.matches || !launcher || launcher.getAttribute('aria-expanded') === 'true' || launcher.matches(':focus-visible')) {
      document.body.classList.remove(hiddenClass);
      return;
    }
    const bounds = launcher.getBoundingClientRect();
    const controls = document.querySelectorAll('#MainContent variant-selects, #MainContent .product-form__buttons, #MainContent .product-popup-modal__button, .monoree-sticky-atc, .cart__footer, .cart-drawer__footer, #MainContent form button, #MainContent form input:not([type=hidden]), #MainContent form textarea, .mobile-facets__footer, .monoree-quick-add-button, .monoree-category-navigation a');
    const blocked = Boolean(document.querySelector('.monoree-quick-add-modal[open], .section-header.menu-open, cart-drawer.active')) || bounds.width > 0 && bounds.height > 0 && Array.from(controls).some(control => {
      const rect = control.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && getComputedStyle(control).visibility !== 'hidden' && overlaps(bounds, rect);
    });
    document.body.classList.toggle(hiddenClass, blocked);
  }
  function schedule() {
    if (!mobile.matches) return;
    if (!frame) frame = requestAnimationFrame(update);
  }
  function watchMobileLayout() {
    layoutObserver.disconnect();
    if (mobile.matches) {
      layoutObserver.observe(document.body, { childList: true, subtree: true });
      schedule();
    } else {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      document.body.classList.remove(hiddenClass);
    }
  }
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  mobile.addEventListener('change', watchMobileLayout);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  const header = document.querySelector('.section-header');
  if (header) new MutationObserver(schedule).observe(header, { attributes: true, attributeFilter: ['class'] });
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  new ResizeObserver(schedule).observe(document.querySelector('#MainContent') || document.body);
  customElements.whenDefined('shopify-chat').then(schedule);
  watchMobileLayout();
})();


(() => {
  const storageKey = 'monoree-catalogue-context';
  const normalizeSize = value => value.trim().replace(',', '.').replace(/\s/g, '');
  document.addEventListener('input', event => {
    const input = event.target.closest('[data-monoree-size-search]');
    if (!input) return;
    event.stopPropagation();
    const root = input.closest('.js-filter');
    const term = normalizeSize(input.value);
    if (!root) return;
    root.classList.toggle('monoree-size-searching', Boolean(term));
    let matches = 0;
    root.querySelectorAll('li').forEach(item => {
      const checkbox = item.querySelector('input[type="checkbox"]');
      if (!checkbox) return;
      const matched = !term || normalizeSize(checkbox.value).includes(term);
      item.classList.toggle('monoree-size-hidden', !matched);
      if (matched) matches++;
    });
    const empty = root.querySelector('.monoree-size-empty');
    if (empty) empty.hidden = matches > 0;
  }, true);

  document.addEventListener('click', event => {
    const guide = event.target.closest('[data-monoree-size-guide]');
    if (guide) {
      document.getElementById(guide.dataset.monoreeSizeGuide)?.show(guide);
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link) return;
    if (link.matches('[data-monoree-accordion-link]')) {
      const target = document.getElementById(link.hash.slice(1));
      if (target) {
        event.preventDefault();
        target.open = true;
        target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        target.querySelector('summary')?.focus({ preventScroll: true });
      }
    }
    if (link.matches('[data-monoree-back-results]') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      try {
        const state = JSON.parse(sessionStorage.getItem(storageKey));
        const destination = new URL(link.href, location.origin);
        if (state?.product === location.pathname && state.url === destination.pathname + destination.search) {
          state.restore = true;
          sessionStorage.setItem(storageKey, JSON.stringify(state));
        }
      } catch {}
    }
    if (!link.closest('#product-grid, .template-search__results')) return;
    const destination = new URL(link.href, location.origin);
    if (destination.origin !== location.origin || !destination.pathname.includes('/products/')) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ url: location.pathname + location.search, product: destination.pathname, label: document.querySelector('#MainContent h1')?.textContent.trim() || '', y: window.scrollY, time: Date.now(), restore: false }));
    } catch {}
  });

  function restoreCatalogueContext(event) {
    let state;
    let destination;
    try {
      state = JSON.parse(sessionStorage.getItem(storageKey));
      if (!state || !Number.isFinite(state.time) || Date.now() - state.time > 1800000) return;
      destination = new URL(state.url, location.origin);
    } catch { return; }
    if (destination.origin !== location.origin || !/\/(collections|search)(\/|$)/.test(destination.pathname)) return;
    const link = document.querySelector('[data-monoree-back-results]');
    if (link && state.product === location.pathname) {
      const defaultPath = new URL(link.href, location.origin).pathname;
      const label = link.querySelector('[data-monoree-back-label]');
      if (label && /\/search(\/|$)/.test(destination.pathname)) {
        label.textContent = link.dataset.backSearch;
      } else if (label && destination.pathname !== defaultPath) {
        label.textContent = state.label && link.dataset.backCategory
          ? link.dataset.backCategory.replace('__CATEGORY__', () => state.label)
          : link.dataset.backCatalogue;
      }
      link.href = state.url;
    }
    const returning = state.restore || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (!event?.persisted && returning && state.url === location.pathname + location.search && Number.isFinite(state.y)) {
      requestAnimationFrame(() => window.scrollTo({ top: state.y, behavior: 'instant' }));
      state.restore = false;
      try { sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch {}
    }
  }
  window.addEventListener('pageshow', restoreCatalogueContext);
  restoreCatalogueContext();

  let reviewFrame = 0;
  let observedReviewWidget = null;
  const reviewSelector = '#judgeme_product_reviews, .jdgm-rev-widg, [data-monoree-review-link]';
  const reviewObserver = new MutationObserver(() => scheduleReviews());
  function updateReviewLink() {
    reviewFrame = 0;
    const widget = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg');
    const link = document.querySelector('[data-monoree-review-link]');
    if (widget !== observedReviewWidget) {
      reviewObserver.disconnect();
      observedReviewWidget = widget;
      if (widget) reviewObserver.observe(widget, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-average-rating'] });
    }
    if (!widget || !link) return;
    const legacy = widget.matches('.jdgm-rev-widg') ? widget : widget.querySelector('.jdgm-rev-widg');
    let count = Number(legacy?.getAttribute('data-number-of-reviews'));
    let rating = Number(legacy?.getAttribute('data-average-rating'));
    const summary = widget.querySelector('.jm-average-rating-display');
    if (summary) {
      const values = [...summary.querySelectorAll('p.jm-text')].map(node => node.textContent.trim());
      rating = Number(values[0]?.replace(',', '.'));
      count = Number(values[1]?.replace(/[^0-9]/g, ''));
    }
    if (!(count > 0 && rating > 0 && rating <= 5)) return;
    const container = widget.closest('#judgeme_product_reviews') || widget;
    if (!container.id) container.id = 'monoree-product-reviews';
    link.href = '#' + container.id;
    const value = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 1 }).format(rating) + ' / 5 (' + count + ')';
    const icon = link.querySelector('span[aria-hidden="true"]');
    if (icon && icon.textContent !== '★') icon.textContent = '★';
    const score = link.querySelector('[data-monoree-review-score]');
    if (score.textContent !== value) score.textContent = value;
    link.hidden = false;
  }
  const scheduleReviews = () => { if (!reviewFrame) reviewFrame = requestAnimationFrame(updateReviewLink); };
  // Only discover added/replaced widgets here; review updates stay local to the widget.
  new MutationObserver(entries => {
    if (entries.some(entry => [...entry.addedNodes, ...entry.removedNodes].some(node => node.nodeType === 1 &&
      (node.matches(reviewSelector) || node.querySelector(reviewSelector))))) scheduleReviews();
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleReviews);
  updateReviewLink();
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !details.closest('#menu-drawer .menu-drawer__navigation')) return;
    const summary = details.querySelector(':scope > summary');
    const container = details.closest('.menu-drawer__navigation-container');
    if (!summary || !container) return;
    requestAnimationFrame(() => {
      const top = summary.getBoundingClientRect().top - container.getBoundingClientRect().top;
      if (top < 0) container.scrollBy({ top: top - 8, behavior: 'instant' });
    });
  }, true);
})();
